// @flow
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { IconLink } from 'app/common/ui-components/app-bar';
import IconBell from 'app/common/icons/IconBell';

import styles from './EventsIcon.scss';


type Props = {
  pathname: string,
}

const EventsIcon = ({ pathname }: Props) => {
  const currentStudentId = useSelector(state => state.settings.current.id, shallowEqual);
  const newEventsCount = useSelector(state => state.events.unread.count, shallowEqual);

  return (
    <IconLink
      to={`/events/${currentStudentId || 'user'}`}
      active={/^\/events(\/|$)/.test(pathname)}
      areaLabel="События"
    >
      <IconBell />
      {newEventsCount ? <div className={styles.dot} /> : null}
    </IconLink>
  );
};

export default EventsIcon;
